import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { StickyNoteIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/configuration-management/hoslog-plans')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="configurationManagement.plans.crumb.hoslogPlans" icon={StickyNoteIcon} />,
      title: <Translation id="configurationManagement.plans.crumb.hoslogPlans" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
